import { getApiUrl } from '../config/api';

export interface StockNotificationResponse {
  success: boolean;
  message: string;
  data?: any;
}

export const subscribeToStockNotification = async (
  email: string,
  productId: string
): Promise<StockNotificationResponse> => {
  try {
    const response = await fetch(getApiUrl('stock_notification.php'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        productId,
      }),
    });

    // Get response text first to handle non-JSON responses
    const responseText = await response.text();
    
    // Check if response is HTML (error page) instead of JSON
    if (responseText.trim().startsWith('<!DOCTYPE') || responseText.trim().startsWith('<html')) {
      throw new Error('Server returned an error page. Please check if the PHP server is running correctly.');
    }

    // Try to parse JSON
    let data: StockNotificationResponse;
    try {
      data = JSON.parse(responseText);
    } catch (parseError) {
      console.error('Failed to parse response:', responseText);
      throw new Error(`Invalid server response: ${responseText.substring(0, 100)}`);
    }

    if (!response.ok) {
      throw new Error(data.message || 'Failed to subscribe to stock notification');
    }

    return data;
  } catch (error: any) {
    console.error('Error subscribing to stock notification:', error);
    
    // Provide user-friendly error messages
    if (error.message) {
      throw new Error(error.message);
    }
    
    throw new Error('Failed to subscribe. Please try again later.');
  }
};

